import contractClaimTranslations from "./contractClaimTranslations";
import addressTranslations from "./addressTranslations";

const employmentContractTranslations = {
  label: "Allgemeines Arbeitsrecht",
  endOfContractDate: {
    label: "Datum Vertragsende",
  },
  ...contractClaimTranslations,
  employmentStartDate: {
    label: "Start Arbeitsverhältnis",
  },
  employmentEndDate: {
    label: "Ende Arbeitsverhältnis",
  },
  employmentRegularWorkplace: {
    label: "Regelmäßiger Arbeitsort",
    values: {
      company: "Sitz des Unternehmens",
      home: "Zu Hause",
      other: "Anderer Ort",
    },
  },
  employmentRegularWorkplaceOtherAddressDescription: {
    label: "Beschreibung Arbeitsort",
  },
  employmentRegularWorkplaceOtherAddress: addressTranslations,
  reasonsForDispute: {
    label: "Problem mit Arbeitgeber",
    values: {
      vacation: "Urlaub",
      overtime: "Überstunden / Freizeitausgleich",
      workCertificate: "Arbeitszeugnis",
      parentalLeave: "Elternzeit",
      partTime: "Teilzeit",
      bullying: "Mobbing / Diskriminierung",
      other: "Anderes Anliegen",
      salary: "Finanzielle Ansprüche aus Lohn",
      claimedPayment: "Geldrückforderung",
      allegedDamage: "Schadensersatzforderung",
      writtenWarning: "Abmahnung",
      termination: "Aufhebungsvertrag prüfen",
      itemsToReturn: "Herausgabeansprüche",
    },
  },
  salaryOutstandingStartDate: {
    label: "Lohn ausstehend seit",
  },
  salaryOutstandingEndDate: {
    label: "Lohn ausstehend bis",
  },
  overtimeAccumulatedTotal: {
    label: "Anzahl offene Überstunden",
  },
  hasOvertimeSurcharge: {
    label: "Regelungen zu Überstundenzuschlägen",
  },
  overtimeSurchargeDetails: {
    label: "Zusatzregelungen Überstundenzuschläge",
  },
  grossSalary: {
    label: "Bruttomonatslohn",
  },
  grossSalarySumLastThreeMonths: {
    label: "Summe Bruttoverdienst letzte 3 Monate",
  },
  vacationDaysLeft: {
    label: "Anzahl offene Urlaubstage",
  },
  weeklyWorkingHours: {
    label: "Regelmäßige wöchentliche Arbeitszeit",
  },
  grossSalaryClaim: {
    label: "Berechneter Brutto-Lohnanspruch",
  },
  grossSalaryClaimFromOvertime: {
    label: "Berechneter Brutto-Lohnanspruch aus Überstunden",
  },
  grossSalaryClaimFromVacationDays: {
    label: "Berechneter Brutto-Lohnanspruch aus Urlaubstagen",
  },
  vacationDenialReason: {
    label: "Grund Ablehnung Urlaubsantrag",
    values: {
      operationalNecessity: "Dringende betriebliche Gründe",
      noVacationDays: "Kein bestehender Urlaubsanspruch",
      requestNotOnTime: "Antrag wurde nicht fristgerecht / zu kurzfristig gestellt",
      noReasonProvided: "Es wurde kein konkreter Grund genannt",
      other: "Anderer Grund",
    },
  },
  yearOfVacationClaim: {
    label: "Anspruch Urlaubsjahr",
  },
  overtimeAccumulatedStartDate: {
    label: "Überstunden angefallen seit",
  },
  overtimeAccumulatedEndDate: {
    label: "Überstunden angefallen bis",
  },
  hoursLeisureCompensation: {
    label: "Anzahl Stunden Freizeitausgleich",
  },
  hasOvertimeRecord: {
    label: "Überstundennachweis vorhanden?",
  },
  workCertificateRequest: {
    label: "Anliegen Arbeitszeugnis",
    values: {
      requestIssuance: "Ich möchte ein Arbeitszeugnis erhalten (habe noch keines bekommen)",
      requestCorrection: "Ich möchte mein bereits erhaltenes Arbeitszeugnis korrigieren lassen.",
    },
  },
  workCertificateIssuanceDenied: {
    label: "Ablehnung Ausstellung Arbeitszeugnis",
  },
  workCertificateIssuanceDenialReason: {
    label: "Begründung Ausstellungsverweigerung",
    values: {
      noEntitlement: "Anspruch wird bestritten",
      unresolvedDispute: "Offene Streitigkeiten/Forderungen",
      insufficientCapacity: "Keine Zeit/Kapazitäten zur Erstellung",
      noReasonProvided: "Keine Begründung genannt",
      other: "Sonstiges",
    },
  },
  workCertificateReceivedAtDate: {
    label: "Arbeitszeugnis erhalten am",
  },
  workCertificateCorrectionRequest: {
    label: "Korrekturbedarf Zeugnis",
    values: {
      performanceEvaluation: "Leistungsbeurteilung (Gesamtnote, Bewertung der Arbeitsleistung)",
      conductEvaluation: "Verhaltensbeurteilung (Umgang mit Kollegen, Vorgesetzten, Kunden)",
      incompleteJobDescription: "Fehlende/unvollständige Tätigkeitsbeschreibung",
      missingKeyAchievements: "Wichtige Erfolge/Aufgaben fehlen",
      factualErrors: "Faktische Fehler (z.B. falsche Daten, Positionsbezeichnung)",
      formalErrors: "Formale Fehler (z.B. fehlende Unterschrift, Datum, falscher Zeugnistyp)",
      negativePhrasingOrCodes: "Negative Formulierungen / Geheimcodes",
      inadequateClosingStatement: "Schlussformel (Dank, Bedauern, gute Wünsche) fehlt/ist unzureichend",
      other: "Sonstiges",
    },
  },

  parentalLeaveStartDate: {
    label: "Beginn Elternzeit",
  },
  parentalLeaveEndDate: {
    label: "Ende Elternzeit",
  },
  hasTakenParentalLeaveBefore: {
    label: "Elternzeit bereits genommen?",
  },
  parentalLeaveSplit: {
    label: "Aufteilung Elternzeit",
  },
  parentalLeaveRequestOnTime: {
    label: "Elternzeit Antrag fristgerecht?",
  },
  parentalLeaveRequestDenied: {
    label: "Ablehnung Elternzeit erfolgt",
  },
  parentalLeaveRequestDeniedReason: {
    label: "Grund Ablehnung Elternzeit",
    values: {
      requestNotOnTime: "Antrag nicht fristgerecht gestellt",
      operationalNecessity: "Dringende betriebliche Gründe",
      formalErrors: "Formalienfehler im Antrag",
      entitlementDisputedByEmployer: "Arbeitgeber bestreitet Anspruch",
      noReasonProvided: "Keine Begründung genannt",
      other: "Sonstiges",
    },
  },
  partTimeStartDate: {
    label: "Start Teilzeit",
  },
  partTimeDesiredWeeklyWorkingHours: {
    label: "Gewünschte wöchentliche Arbeitszeit Teilzeit",
  },
  numberOfEmployees: {
    label: "Mitarbeiter im Unternehmen",
  },
  partTimeDenialReason: {
    label: "Grund Ablehnung Teilzeit",
    values: {
      operationalReasons: "Betriebliche Gründe",
      disproportionateCosts: "Kosten sind unverhältnismäßig",
      requirementsNotMet: "Voraussetzungen nicht erfüllt",
      formalErrors: "Formalienfehler im Antrag",
      noReasonProvided: "Keine Begründung genannt",
      other: "Sonstiges",
    },
  },
  incidentType: {
    label: "Klassifizierung Vorfall",
    values: {
      bullying: "Mobbing",
      discrimination: "Diskriminierung",
    },
  },
  incidentStartDate: {
    label: "Anfangszeitpunkt Mobbing/Diskriminierung",
  },
  incidentObjectiveClient: {
    label: "Erhoffte Maßnahme Mandant",
    values: {
      injunction: "Unterlassung des Verhaltens",
      compensation: "Schadensersatz",
      other: "Sonstiges",
    },
  },
  claimedPaymentTypes: {
    label: "Art der Rückforderung",
    values: {
      salary: "Zu viel gezahlter Lohn/Gehalt",
      bonus: "Zu viel gezahlte Boni/Provisionen",
      training: "Rückzahlung von Fortbildungskosten",
      loan: "Rückzahlung von Darlehen/Vorschüssen",
      other: "Sonstiges",
    },
  },
  claimedPaymentReason: {
    label: "Begründung Rückforderung Arbeitgeber",
  },
  allegedDamageTypes: {
    label: "Vorgeworfener Schaden Arbeitgeber",
    values: {
      damageOrLossOfProperty: "Beschädigung/Verlust von Firmeneigentum",
      breachOfNonCompete: "Verstoß gegen Geheimhaltungspflicht",
      breachOfConfidentiality: "Verstoß gegen Wettbewerbsverbot",
      poorPerformance: "Schlechtleistung/Pflichtverletzung",
      embezzlementOrTheft: "Untreue/Diebstahl",
      other: "Sonstiges",
    },
  },
  allegedDamageDate: {
    label: "Datum Vorfall Schadensersatz",
  },
  writtenWarningReceivedDate: {
    label: "Abmahnung erhalten am",
  },
  writtenWarningReason: {
    label: "Grund für Abmahnung",
  },
  writtenWarningIllegalReasons: {
    label: "Abmahnung unrechtmäßig weil",
    values: {
      factuallyIncorrect: "Der Sachverhalt stimmt nicht ",
      disproportionateWarning: "Die Abmahnung ist unverhältnismäßig",
      formalErrors: "Es gibt Formfehler (z.B. keine genaue Bezeichnung)",
      other: "Sonstiges",
    },
  },
  terminationAgreementOfferDate: {
    label: "Datum Angebot Aufhebungsvertrag",
  },
  terminationAgreementDeadlineDate: {
    label: "Frist Unterschrift Aufhebungsvertrag",
  },
  terminationAgreementIncludesSettlement: {
    label: "Abfindungszahlung in Aufhebungsvertrag?",
  },
  offeredSettlementPayment: {
    label: "Angebotene Abfindung",
  },
  terminationAgreementObjectivesClient: {
    label: "Ziel Prüfung Aufhebungsvertrag",
    values: {
      maximizeSettlement: "Maximierung der Abfindung",
      avoidUnemploymentPenalty: "Vermeidung einer Sperrzeit beim Arbeitslosengeld",
      securePositiveWorkCertificate: "Positives Arbeitszeugnis sichern",
      achieveImmediateRelease: "Sofortige Freistellung erreichen",
      negotiateOtherTerms: "Andere Bedingungen verhandeln",
      remainEmployed: "Ich möchte den Vertrag nicht unterschreiben, sondern im Arbeitsverhältnis bleiben",
      other: "Sonstiges",
    },
  },
  itemsToReturn: {
    label: "Forderung Herausgabe Arbeitgeber",
    values: {
      companyCar: "Dienstwagen",
      laptopOrTablet: "Laptop / Tablet Diensthandy",
      companyPhone: "Diensthandy",
      keysOrAccessCards: "Schlüssel / Zugangskarten",
      toolsOrEquipment: "Arbeitsgeräte / Werkzeuge",
      companyDocuments: "Unternehmensdokumente / Daten",
      other: "Sonstiges",
    },
  },
  itemsToReturnReason: {
    label: "Begründung Herausgabeanspruch",
  },
  itemsToReturnRejectionReasons: {
    label: "Grund Ablehnung Forderung",
    values: {
      itemsBelongToMe: "Die geforderten Gegenstände/Unterlagen gehören mir.",
      itemsNeededForWork: "Ich benötige die Gegenstände/Unterlagen für meine Arbeit.",
      notContractuallyAgreed: "Die Forderung ist nicht vertraglich vereinbart.",
      disproportionateClaim: "Die Forderung ist unverhältnismäßig.",
      claimExpired: "Die Forderung ist verjährt.",
      other: "Sonstiges",
    },
  },
};

export default employmentContractTranslations;
